import { lazy } from 'react';

const CustomPlanificador = lazy(() => import('./CustomPlanificador'));

export default CustomPlanificador;
